/**
 * TrainingPage - Admin page for managing training plans
 */
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import TrainingPlans from '@/components/TrainingPlans';

const TrainingPage = () => {
  const { token } = useAuth();

  return (
    <div className="p-6">
      <TrainingPlans token={token} />
    </div>
  );
};

export default TrainingPage;
